import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { FillScreen, HStack, VStack } from '@/components/Layout';
import { Separator } from '@/components/ui/separator';
import { PackageSidebar, type SidebarState } from '@/features/operation-package/PackageSidebar';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useTranslation } from '@/lib/i18n';
import { MockContent } from './-components/MockContent';
import { QaOperationsCoreHeader } from './-components/QaOperationsCoreHeader';
import { TestPlanPanel } from './-components/TestPlanPanel';
export const Route = createFileRoute('/_stacktrace/qa-operations-core/')({
  component: QaOperationsCorePage
});
const TEST_PLAN_ID = 'test-plan';
const SIDEBAR_GROUPS = [{
  packages: [{
    id: TEST_PLAN_ID,
    label: 'テスト計画'
  }, {
    id: 'test-review',
    label: 'テストレビュー',
    isUnderDevelopment: true
  }]
}, {
  packages: [{
    id: 'test-asset-inventory',
    label: 'テストアセット棚卸し',
    isUnderDevelopment: true
  }, {
    id: 'test-asset-registration',
    label: 'テストアセット登録',
    isUnderDevelopment: true
  }]
}, {
  packages: [{
    id: 'defect-inventory',
    label: '不具合棚卸し',
    isUnderDevelopment: true
  }, {
    id: 'enhance-report-inventory',
    label: 'エンハンス報告棚卸し',
    isUnderDevelopment: true
  }]
}];
function QaOperationsCorePage() {
  const {
    t
  } = useTranslation();
  const title = t('component.sidebar.qaForceOperationsCore');
  useDocumentTitle(title);
  const [activeId, setActiveId] = useState<string>(SIDEBAR_GROUPS[0].packages[0].id);
  const [sidebarState, setSidebarState] = useState<SidebarState>('open');
  const activeLabel = SIDEBAR_GROUPS.flatMap(group => group.packages).find(item => item.id === activeId)?.label ?? '';
  return <VStack className="h-full">
      <QaOperationsCoreHeader />
      <FillScreen>
        <HStack className="h-full w-full max-w-screen">
          <PackageSidebar groups={[...SIDEBAR_GROUPS]} activeId={activeId} onSelect={setActiveId} sidebarState={sidebarState} onStateChange={setSidebarState} underDevelopmentText="現在開発中の業務パッケージです。" />
          <Separator orientation="vertical" />
          {activeId === TEST_PLAN_ID ? <TestPlanPanel /> : <MockContent activeLabel={activeLabel} />}
        </HStack>
      </FillScreen>
    </VStack>;
}